module.exports = __webpack_public_path__ + "static/media/1.642b8062.png";